import { GrapeVarieties, PriceRanges, Regions, WineProducers, WineSizes, WineTypes } from '../utils/constants';

const wineData = [
  { 
    name: 'Espumante Rosé',
    image: "/images/ESPUMANTE_ROSE.png",
    year: '',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.SPARKLING,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Blanc de Noirs Brut Nature',
    year: '2020',
    image: '/images/BLANC_NOIR.png',
    grapeVarieties: [GrapeVarieties.TINTA_RORIZ, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.SPARKLING,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Rosa Maria Rosé',
    year: '2017',
    image: '/images/ROSAMARIA17.png',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.ROSE,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_UNDER_5,
  },
  {
    name: 'Avó Fernanda Blended',
    year: '2023',
    image: '/images/Avo-Fernanda-2023-1.png',
    grapeVarieties: [GrapeVarieties.BICAL, GrapeVarieties.ENCRUZADO, GrapeVarieties.MALVASIA_FINA],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Pessegueiro Colheita',
    year: '2024',
    image: '/images/QDP-Colheita-Branco-2023.jpg',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2025/11/FT-Pessegueiro-Colheita-Branco-2024.pdf',
    grapeVarieties: [GrapeVarieties.RABIGATO, GrapeVarieties.VIOSINHO, GrapeVarieties.GOUVEIO],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Qta Pessegueiro Viosinho',
    year: '2024',
    image: '/images/pessegueiro/pessegueiro-branco-viosinho-2024.png',
    sheet: '/sheets/qdp-viosinho24.pdf',
    grapeVarieties: [GrapeVarieties.VIOSINHO],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Qta Couquinho Colheita',
    year: '2023',
    image: '/images/qdc-colheita-branco.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2026/07/2024-Couquinho-Colheita-Branco.pdf',
    grapeVarieties: [GrapeVarieties.RABIGATO, GrapeVarieties.VIOSINHO, GrapeVarieties.GOUVEIO],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Qta Couquinho Encostas do Gavião Branco',
    year: '2022',
    image: '/images/qdc-branco-encostas-gaviao-2021.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2023/03/2021-EG-Branco.pdf',
    grapeVarieties: [GrapeVarieties.RABIGATO, GrapeVarieties.CODEGA_DO_LARINHO],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_UNDER_5,
  },
  {
    name: 'Pessegueiro Reserva',
    year: '2024',
    image: '/images/pessegueiro/pessegueiro-branco-reserva-2024.png',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2026/02/FT-Reserva-Branco-2024-capsula-branca.pdf',
    grapeVarieties: [GrapeVarieties.RABIGATO, GrapeVarieties.FOLGASAO],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Qta Pessegueiro Grande Reserva Branco',
    year: '2024',
    image: '/images/pessegueiro/pessegueiro-branco-grande-reserva-2024.png',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2026/02/FT-QP-BRANCO-2024.pdf',
    grapeVarieties: [GrapeVarieties.RABIGATO, GrapeVarieties.FOLGASAO],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Avô António Encruzado',
    year: '2024',
    image: '/images/AVO-ANTONIO.png',
    grapeVarieties: [GrapeVarieties.ENCRUZADO],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Lux Edition Tinto',
    year: '2024',
    image: '/images/monteirinhos-tinto-lux-edition-2024.png',
    sheet: '/sheets/monteirinhos-tinto-lux-edition-2024.jpeg',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL, GrapeVarieties.TINTA_RORIZ, GrapeVarieties.JAEN],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_UNDER_5,
  },
  {
    name: 'Lux Edition Branco',
    year: '2025',
    image: '/images/monteirinhos-branco-lux-edition-2025.png',
    sheet: '/sheets/monteirinhos-branco-lux-edition.jpeg',
    grapeVarieties: [GrapeVarieties.MALVASIA_FINA, GrapeVarieties.CERCEAL, GrapeVarieties.BICAL],
    type: WineTypes.WHITE,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_UNDER_5,
  },
  {
    name: 'Menino Afonso Reserva',
    year: '2020',
    image: '/images/MENINOAFONSO20.png',
    sheet: '',
    grapeVarieties: [GrapeVarieties.JAEN, GrapeVarieties.TINTA_RORIZ, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Pessegueiro Colheita',
    year: '2021',
    image: '/images/qdp-tinto-colheita-21.png',
    sheet: '/sheets/qdp-tinto-21.pdf',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL, GrapeVarieties.TOURIGA_FRANCA],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Qta Couquinho Colheita',
    year: '2023',
    image: '/images/qdc-colheita-tinto.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2026/01/2023-QC-Colheita.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_UNDER_10,
  },
  {
    name: 'Qta Couquinho Encostas do Gavião Tinto',
    year: '2024',
    image: '/images/qdc-tinto-encostas-gaviao.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2026/04/2024-EG-Tinto.pdf',
    grapeVarieties: [GrapeVarieties.TINTA_RORIZ, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL, GrapeVarieties.ALICANTE_BOUSCHET],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_UNDER_5,
  },
  {
    name: 'Qta Pessegueiro Tinta Roriz',
    year: '2023',
    image: '/images/pessegueiro/pessegueiro-tinto-tinta-roriz-2023.png',
    sheet: '/sheets/qdp-roriz23.pdf',
    grapeVarieties: [GrapeVarieties.TINTA_RORIZ],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Pessegueiro Reserva',
    year: '2023',
    image: '/images/qdp-reserva-tinto.jpg',
    sheet: '/sheets/qdp-reserva-23.pdf',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TINTA_BARCA],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Qta Couquinho Reserva',
    year: '2021',
    image: '/images/qdc-reserva-tinto.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2025/01/2021-QC-Reserva-English.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Qta Pessegueiro Grande Reserva',
    year: '2021',
    image: '/images/pessegueiro/pessegueiro-tinto-grande-reserva.png',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2025/11/FT-QUINTA-DO-PESSEGUEIRO-2020.pdf',
    grapeVarieties: [GrapeVarieties.VINHAS_VELHAS, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Qta Pessegueiro Tinta da Barca & Alicante Bouschet',
    year: '2024',
    image: '/images/pessegueiro/pessegueiro-tinto-tinta-barca-alicante-bouschet-2024.png',
    sheet: '',
    grapeVarieties: [GrapeVarieties.TINTA_BARCA, GrapeVarieties.ALICANTE_BOUSCHET],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Adeodato Sousão Reserva',
    year: '2019',
    image: '/images/qdc-adeodato.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2024/10/2019-QC-Adeodato-English.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Unius',
    year: '2020',
    image: '/images/qdc-unius-2020.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2023/10/2020-QC-UNIUS-Reserva-English.pdf',
    grapeVarieties: [GrapeVarieties.TINTO_CAO, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Qta Couquinho Grande Reserva',
    year: '2019',
    image: '/images/qdc-grande-reserva.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2024/10/2019-QC-Grande-Reserva-English.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_35_50,
  },
  {
    name: 'Plenitude',
    year: '2023',
    image: '/images/plenitude.jpg',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2026/02/FT-PLENITUDE-2023.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO, GrapeVarieties.VINHAS_VELHAS, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_35_50,
  },
  {
    name: 'Manel Chaves Touriga Nacional',
    year: '2022',
    image: '/images/Manel-Chaves-2022.png',
    sheet: '',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Pai Miguel',
    year: '2022',
    image: '/images/monteirinhos-pai-miguel-2022.png',
    sheet: '',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.MONTEIRINHOS,
    region: Regions.DAO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Qta Couquinho Reserva Touriga Nacional',
    year: '2021',
    image: '/images/qdc-tn-reserva.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2025/01/2021-QC-TN-Reserva-English.pdf',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Qta Pessegueiro Touriga Nacional',
    year: '2024',
    image: '/images/pessegueiro/pessegueiro-tinto-touriga-nacional-2024.png',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2025/11/FT-Touriga-Nacional-2019.pdf',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Qta Pessegueiro Tinto Cão',
    year: '2023',
    image: '/images/pessegueiro/pessegueiro-tinto-tinto-cao-2023.png',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2024/11/FT-Tinto-Cao-2022.pdf',
    grapeVarieties: [GrapeVarieties.TINTO_CAO],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Qta Pessegueiro Rufete',
    year: '2021',
    image: '/images/pessegueiro/pessegueiro-tinto-rufete-2021.png',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2024/11/FT-RUFETE-2021.pdf',
    grapeVarieties: [GrapeVarieties.RUFETE],
    type: WineTypes.RED,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Qta Couquinho Colheita',
    year: '2020',
    image: '/images/qdc-colheita-magnum.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2024/03/2020-QC-Colheita-English.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.MAGNUM,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Qta Couquinho Touriga Nacional',
    year: '2023',
    image: '/images/qdc-tn-reserva-magnum.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2025/01/2021-QC-TN-Reserva-English.pdf',
    grapeVarieties: [GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.MAGNUM,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_35_50,
  },
  {
    name: 'Qta Pessegueiro Grande Reserva',
    year: '2019',
    image: '/images/qdp-grande-reserva.jpg',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2023/12/QDP-20230206-FT-Quinta-do-Pessegueiro-Grande-Reserva-Tinto-2019.pdf',
    grapeVarieties: [GrapeVarieties.VINHAS_VELHAS, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.MAGNUM,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_35_50,
  },
  {
    name: 'Qta Couquinho Reserva',
    year: '2019',
    image: '/images/qdc-reserva-tinto-magnum.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2024/03/2020-QC-Reserva.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.MAGNUM,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_35_50,
  },
  {
    name: 'Adeodato Sousão',
    year: '2019',
    image: '/images/qdc-adeodato-magnum.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2024/10/2019-QC-Adeodato-English.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO],
    type: WineTypes.RED,
    size: WineSizes.MAGNUM,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_50_100,
  },
  {
    name: 'Unius',
    year: '2020',
    image: '/images/qdc-unius-magnum.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2023/10/2020-QC-UNIUS-Reserva-English.pdf',
    grapeVarieties: [GrapeVarieties.TINTO_CAO, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.MAGNUM,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_50_100,
  },
  {
    name: 'Qta Couquinho Grande Reserva',
    year: '2019',
    image: '/images/qdc-grande-reserva-magnum.webp',
    sheet: 'https://quintadocouquinho.pt/wp-content/uploads/2024/10/2019-QC-Grande-Reserva-English.pdf',
    grapeVarieties: [GrapeVarieties.SOUSAO, GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.RED,
    size: WineSizes.MAGNUM,
    producer: WineProducers.COUQUINHO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_50_100,
  },
  {
    name: 'Qta Pessegueiro Branco',
    year: '',
    image: '/images/qdp-porto-branco.jpg',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2023/03/FT-PORTO-WHITE-2021.pdf',
    grapeVarieties: [GrapeVarieties.VINHAS_VELHAS, GrapeVarieties.GOUVEIO, GrapeVarieties.RABIGATO],
    type: WineTypes.PORTO,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Qta Pessegueiro LBV',
    year: '2018',
    image: '/images/qdp-lbv.jpg',
    sheet: 'https://www.quintadopessegueiro.com/wp-content/uploads/2024/11/FT-Porto-LBV-2018.pdf',
    grapeVarieties: [GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.PORTO,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_10_20,
  },
  {
    name: 'Qta Pessegueiro Colheita 2012',
    year: '2012',
    image: '/images/qdp-porto-colheita-12.png',
    sheet: '/sheets/qdp-porto-colheita-12.pdf',
    type: WineTypes.PORTO,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_20_35,
  },
  {
    name: 'Qta Pessegueiro Vintage',
    year: '2021',
    image: '/images/qdp-vintage21.png',
    sheet: '',
    grapeVarieties: [GrapeVarieties.TOURIGA_FRANCA, GrapeVarieties.TOURIGA_NACIONAL],
    type: WineTypes.PORTO,
    size: WineSizes.STANDARD,
    producer: WineProducers.PESSEGUEIRO,
    region: Regions.DOURO,
    priceRange: PriceRanges.RANGE_35_50,
  },
  {
    name: 'Mumm',
    image: '/images/mumm.png',
    grapeVarieties: [GrapeVarieties.PINOT_NOIR, GrapeVarieties.PINOT_MEUNIER, GrapeVarieties.CHARDONNAY],
    type: WineTypes.CHAMPAGNE,
    size: WineSizes.STANDARD,
    producer: WineProducers.MUMM,
    region: Regions.CHAMPAGNE,
    priceRange: PriceRanges.RANGE_20_35,
  }
];

export default wineData;
